








































































































import { Component, Prop } from "vue-property-decorator";
import i18n from "@/services/i18n";
import auth from "@/services/auth";
import { ComponentBase, Overlay } from "../components";
import * as common from '../common';
import { BudgetVariants, Comp, Dict } from "../types";
import * as reportsCommon from './common';


interface ReportType {
    code: string;
    name: string;
}


const translates = {
    actions: {
        get generate(): string {
            return i18n.choose(
                'Сформировать',
                'Форма',
                'Form',
            );
        },
    },
    errors: {
        get cannotLoadBudgetRegions(): string {
            return i18n.choose(
                'Не удалось загрузить регионы',
                'Аймақтар жүктелмеді',
                'Failed to load regions',
            );
        },
        get cannotLoadBudgetVariants(): string {
            return i18n.choose(
                'Не удалось загрузить варианты бюджета',
                'Бюджет опциялары жүктелмеді',
                'Failed to load budget options',
            );
        },
        get cannotLoadMaxReportYear(): string {
            return i18n.choose(
                'Не удалось загрузить максимальный год отчета',
                'Ең көп есеп беру жылы жүктелмеді',
                'Failed to load max report year',
            );
        },
        get cannotScheduleGeneration(): string {
            return i18n.choose(
                'Не удалось запланировать генерацию отчета',
                'Есеп жасауды жоспарлау сәтсіз аяқталды',
                'Cannot schedule report generation',
            );
        }
    },
    fields: {
        budgetVariant: {
            get title(): string {
                return i18n.choose(
                    'Версия бюджета',
                    'Бюджеттік нұсқа',
                    'Budget version',
                );
            },
            status: {
                values: {
                    get actual(): string {
                        return i18n.choose(
                            'Актуально',
                            'Ток',
                            'Actual',
                        );
                    },
                    get approved(): string {
                        return i18n.choose(
                            'Утверждено',
                            'Бекіту',
                            'Approved',
                        );
                    },
                },
            },
        },
        newArrivals: {
            get title(): string {
                return i18n.choose(
                    'Новоприбывшие',
                    'Жаңа келгендер',
                    'New arrivals',
                );
            },
        },
        republicBudget: {
            get title(): string {
                return i18n.choose(
                    'РБ',
                    'РБ',
                    'RB',
                );
            },
        },
        region: {
            get title(): string {
                return i18n.choose(
                    'Регион',
                    'Аймақ',
                    'Region',
                );
            },
        },
        reportDate: {
            get title(): string {
                return i18n.choose(
                    'Дата отчета',
                    'Есеп беру күні',
                    'Report date',
                );
            },
        },
        reportType: {
            get title(): string {
                return i18n.choose(
                    'Тип отчета',
                    'Есеп түрі',
                    'Report type',
                );
            },
            values: {
                get all(): string {
                    return i18n.choose(
                        'Все',
                        'Барлығы',
                        'All',
                    );
                },
                get civil(): string {
                    return i18n.choose(
                        'Гражданские служащие',
                        'Азаматтық қызметкерлер',
                        'Civil servants',
                    );
                },
                get gov(): string {
                    return i18n.choose(
                        'Государственные служащие',
                        'Мемлекеттік қызметшілер',
                        'Government servants',
                    );
                },
                get mvd(): string {
                    return i18n.choose(
                        'Правоохранительные органы',
                        'Құқық қорғау органдары',
                        'Law enforcement agencies',
                    );
                },
            },
        },
        reportYear: {
            get title(): string {
                return i18n.choose(
                    'Год отчета',
                    'Есеп беру жылы',
                    'Report year',
                );
            },
        },
    },
    messages: {
        dataSaved(id: number): string {
            return i18n.choose(
                `Генерация отчета запланирована, ID #${id}`,
                `Есепті жасау жоспарланған, ID #${id}`,
                `Report generation scheduled, ID #${id}`,
            );
        },
    },
};


const events = {
    reportSaved: 'report-saved',
};


@Component({
    components: {
        Overlay,
    },
})
export default class GenerateFzpReport extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    protected created() {
        super.created();

        // region Регион
        this.$watch('selectedRegion', () => {
            this.selectedBudgetVariant = null;
            this.budgetVariants = [];
            this.loadBudgetVariantsIfPossible();
        });
        // endregion

        // region Другие данные - год отчета, дата отчета, тип отчета, "Новоприбывшие", "РБ"
        this.$watch('reportYear', () => {
            this.selectedBudgetVariant = null;
            this.budgetVariants = [];
            this.loadBudgetVariantsIfPossible();
        });
        // endregion

        // По умолчанию выбираем "Все"
        this.selectedReportType = this.reportTypes[0];
    }

    protected mounted() {
        super.mounted();

        this.loadRegions();
        this.loadAndApplyMaxReportYear();
    }
    // endregion


    // region Утилиты
    public translates = translates;

    public get loading(): boolean {
        return this.loadingRegions || this.loadingMaxReportYear || this.loadingBudgetVariants || this.awaitingScheduleGenerationResponse;
    }

    public get debug(): boolean {
        return (common.debugUtilObject.get(common.debugUtilKeys.reports.fzp.debug) == true);
    }
    // endregion


    // region Регион
    public loadingRegions: boolean = false;

    public regions: Dict.BudgetRegions[] = [];

    public get regionOptions(): Array<Comp.DropdownItemDef<Dict.BudgetRegions>> {
        return this.regions.map((region: Dict.BudgetRegions): Comp.DropdownItemDef<Dict.BudgetRegions> => {
            const title = i18n.choose(
                region.nameRu ?? region.id?.toString() ?? '',
                region.nameKk ?? region.nameRu ?? region.id?.toString() ?? '',
                region.nameRu ?? region.id?.toString() ?? '',
            );

            const code = region.code = region.code ?? region.id?.toString() ?? '';

            return {
                text: `${code} - ${title}`,
                value: region,
            };
        });
    }

    public selectedRegion: Comp.DropdownItemDef<Dict.BudgetRegions> | null = null;

    public get selectedRegionCode(): string | null {
        const selectedRegion = this.selectedRegion;
        if (selectedRegion === null) {
            return null;
        } else {
            return selectedRegion.value.code;
        }
    }

    public get selectedRegionText(): string | null {
        return this.selectedRegion?.text ?? null;
    }

    public loadRegions() {
        if (this.loadingRegions) {
            console.error('Cannot load regions - another loading is running');
            return;
        }

        this.loadingRegions = true;

        const userId = auth.user.sub;

        /*
        GET http://<host>[:<port>]/api/budget/staffing_table/fzp/regions?
            user-id={{$placeholder}}
         */
        const url = this.prepareUrl(
            '/api/budget/staffing_table/fzp/regions',
            [
                ['user-id', userId],
            ],
        );

        this.request<Array<Dict.BudgetRegions>>(
            {
                url,
                method: 'GET',
            },
            (data) => {
                this.regions = data;
                if (this.regionOptions.length > 0) {
                    this.selectedRegion = this.regionOptions[0];
                }
            },
            () => this.translates.errors.cannotLoadBudgetRegions,
            () => {
                this.loadingRegions = false;
            },
        );
    }

    public get isRegionForReportDate(): boolean {
        const selectedRegion = this.selectedRegion;
        if (selectedRegion === null) {
            return false;
        }

        const code = selectedRegion.value.code;
        if (code === null) {
            return false;
        }

        return code.endsWith('00');
    }
    // endregion


    // region Год отчета
    /**
     * Год отчета
     */
    public reportYear: number = new Date().getFullYear();

    public loadingMaxReportYear: boolean = false;

    public loadAndApplyMaxReportYear() {
        if (this.loadingMaxReportYear) {
            console.error('Cannot load max report year - another loading is running');
            return;
        }

        const userId = auth.user.sub;

        /*
        GET http://<host>[:<port>]/api/budget/staffing_table/fzp/max-year?
            user-id={{$placeholder}}
         */
        const url = this.prepareUrl(
            '/api/budget/staffing_table/fzp/max-year',
            [
                ['user-id', userId],
            ],
        );

        this.loadingMaxReportYear = true;

        this.request<number>(
            {
                url,
                method: 'GET',
            },
            (data) => {
                this.reportYear = data;
            },
            () => this.translates.errors.cannotLoadMaxReportYear,
            () => {
                this.loadingMaxReportYear = false;
            },
        );
    }
    // endregion


    // region Вариант бюджета
    public loadingBudgetVariants: boolean = false;

    public budgetVariants: BudgetVariants[] = [];

    public get budgetVariantOptions(): Array<Comp.DropdownItemDef<BudgetVariants>> {
        return this.budgetVariants.map((budgetVariant: BudgetVariants): Comp.DropdownItemDef<BudgetVariants> => {
            const title = i18n.choose(
                budgetVariant.nameRu ?? budgetVariant.id?.toString() ?? '',
                budgetVariant.nameKk ?? budgetVariant.nameRu ?? budgetVariant.id?.toString() ?? '',
                budgetVariant.nameEn ?? budgetVariant.nameRu ?? budgetVariant.nameKk ?? budgetVariant.id?.toString() ?? '',
            );

            const statuses: Array<string> = [];
            if (budgetVariant.attribute) {
                statuses.push(translates.fields.budgetVariant.status.values.actual);
            }
            if (budgetVariant.status) {
                statuses.push(translates.fields.budgetVariant.status.values.approved);
            }

            let status: string;
            if (statuses.length > 0) {
                status = ` (${statuses.join(', ')})`;
            } else {
                status = '';
            }

            return {
                text: `${title}${status}`,
                value: budgetVariant,
            };
        });
    }

    public selectedBudgetVariant: Comp.DropdownItemDef<BudgetVariants> | null = null;

    public get selectedBudgetVariantText(): string | null {
        return this.selectedBudgetVariant?.text ?? null;
    }

    public loadBudgetVariants() {
        if (this.loadingBudgetVariants) {
            console.error('Cannot load budget variants - another loading is running');
            return;
        }

        const selectedRegionCode = this.selectedRegionCode;
        if (selectedRegionCode === null) {
            console.error('Cannot load budget variants - no region selected or region code is null');
            return;
        }

        this.loadingBudgetVariants = true;

        this.request<Array<BudgetVariants>>(
            {
                url: `/api/budget/staffing_table/budget-variants-storage?year=${this.reportYear}&region-code=${selectedRegionCode}`,
            },
            (data) => {
                this.budgetVariants = data;
                if (this.budgetVariantOptions.length > 0) {
                    const actualBudgetVariant = this.budgetVariantOptions.find((budgetVariantItemDef) => {
                        return (budgetVariantItemDef.value.attribute === true);
                    });
                    this.selectedBudgetVariant = actualBudgetVariant ?? this.budgetVariantOptions[0];
                } else {
                    this.selectedBudgetVariant = null;
                }
            },
            () => this.translates.errors.cannotLoadBudgetVariants,
            () => {
                this.loadingBudgetVariants = false;
            },
        );
    }

    public loadBudgetVariantsIfPossible() {
        if (this.selectedRegionCode === null) {
            return;
        }
        this.loadBudgetVariants();
    }
    // endregion


    // region Другие данные - год отчета, дата отчета, тип отчета, "Новоприбывшие", "РБ"
    /**
     * Опции для типа отчета
     */
    public get reportTypes(): Array<ReportType> {
        return [
            { code: 'ALL', name: this.translates.fields.reportType.values.all },
            { code: 'GOV', name: this.translates.fields.reportType.values.gov },
            { code: 'CIVIL', name: this.translates.fields.reportType.values.civil },
            { code: 'MVD', name: this.translates.fields.reportType.values.mvd },
        ];
    }

    /**
     * Дата отчета
     */
    public reportDate: Date = new Date();

    /**
     * Выбранный тип отчета
     */
    public selectedReportType: ReportType | null = null;

    /**
     * "Новоприбывшие"
     */
    public newArrivals: boolean = false;

    /**
     * "РБ" ("республиканский бюджет")
     */
    public republicBudget: boolean = false;
    // endregion


    // region Генерация
    public awaitingScheduleGenerationResponse: boolean = false;

    public scheduleGeneration() {
        if (this.awaitingScheduleGenerationResponse) {
            console.error('Cannot schedule generation - another generation schedule is running');
            return;
        }


        // region Параметры, URL
        const regionCode = this.selectedRegionCode;
        if (regionCode === null) {
            console.error('Cannot schedule generation - no region selected or region code is null');
            return;
        }

        const reportYear = this.reportYear;

        let budgetVariantUuid: string | null = null;
        let reportDate: string | null = null;

        if (this.isRegionForReportDate) {
            const reportDateObject = this.reportDate;
            reportDate = `${reportDateObject.getFullYear().toString().padStart(4, '0')}-${(reportDateObject.getMonth() + 1).toString().padStart(2, '0')}-${reportDateObject.getDate().toString().padStart(2, '0')}`;
        } else {
            const selectedBudgetVariantUuid = this.selectedBudgetVariant?.value?.variantUuid ?? null;
            if (selectedBudgetVariantUuid === null) {
                console.error('Cannot schedule generation - no budget variant selected');
                return;
            }
            budgetVariantUuid = selectedBudgetVariantUuid;
        }

        const reportType = this.selectedReportType?.code ?? null;
        if (reportType === null) {
            console.error('Cannot schedule generation - no report type selected');
        }

        const newArrivals = this.newArrivals;

        const republicBudget = this.republicBudget;

        const userId = auth.user.sub;
        const userName = auth.user.login;

        const url = this.prepareUrl(
            '/api/budget/staffing_table/fzp/schedule-generation',
            [
                ['region-code', regionCode],
                ['report-year', reportYear],
                ['budget-variant-uuid', budgetVariantUuid],
                ['report-date', reportDate],
                ['report-type', reportType],
                ['new-arrivals', newArrivals],
                ['republic-budget', republicBudget],
                ['user-id', userId],
                ['user-name', userName],
                ['debug', this.debug],
            ],
        );
        // endregion


        this.awaitingScheduleGenerationResponse = true;

        this.request<number>(
            {
                url,
                method: 'POST',
            },
            (data) => {
                this.$emit(events.reportSaved, data);
            },
            () => this.translates.errors.cannotScheduleGeneration,
            () => {
                this.awaitingScheduleGenerationResponse = false;
            },
        );
    }
    // endregion
}
